<template>
  <div
    class="bg-background-neutral-secondary flex flex-col items-center space-y-4 rounded-2xl p-4"
  >
    <img
      src="@/assets/images/medical-insurance-error-icon.svg"
      width="64"
      height="64"
      alt=""
      role="presentation"
    />
    <div class="text-center">
      <p class="text-text-neutral-primary text-lg font-semibold">
        {{ t('ancillaries.medicalInsurance.error.title') }}
      </p>
      <p class="text-text-neutral-quaternary text-sm">
        {{ t('ancillaries.medicalInsurance.error.contentText') }}
      </p>
    </div>
    <FreeButton
      :disabled="isLoading"
      class="gray-button w-full"
      @click="$emit('onRetry')"
      >{{ t('general.retry') }}</FreeButton
    >
    <FreeButton
      class="gray-button w-full"
      @click="$emit('onContinueWithoutInsurance')"
      >{{
        t('ancillaries.medicalInsurance.continueWithoutInsurance')
      }}</FreeButton
    >
  </div>
</template>
<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { FreeButton } from 'freedom-shared';

  defineProps<{
    isLoading: boolean;
  }>();

  defineEmits<{
    onRetry: [];
    onContinueWithoutInsurance: [];
  }>();

  const { t } = useI18n();
</script>
